module.exports = __webpack_public_path__ + "img/hospitium-02.85c34da0.jpg";